import { Grid } from '@chakra-ui/react';

import { AdditionalInformationItem } from './SummaryCard/AdditionalInformationItem';
import { FinancingProductItem } from './SummaryCard/FinancingProductItem';
import { ProgressItem } from './SummaryCard/ProgressItem';

export type SummaryCardProps = {
  isCompleted?: boolean;
  completedValue?: number;
  progressIncrement?: number;
  progressTotal?: number;
  openTaskId?: string;
  canShowProgress?: boolean;
};

export const HausbankSummaryCard = ({
  isCompleted,
  completedValue,
  progressIncrement,
  progressTotal,
  openTaskId,
  canShowProgress = true,
}: SummaryCardProps) => {
  return (
    <Grid
      templateColumns={['repeat(1, 1fr)', null, null, 'repeat(3, 1fr)']}
      gap={12}
      as="section"
      border="1px"
      borderColor="border.lightGrey"
      p={8}
      boxShadow="default"
      bgColor="background.white"
    >
      <FinancingProductItem />
      <AdditionalInformationItem justifyContent="center" />
      <ProgressItem
        isCompleted={isCompleted}
        completedValue={completedValue}
        progressIncrement={progressIncrement}
        progressTotal={progressTotal}
        openTaskId={openTaskId}
        canShowProgress={canShowProgress}
      />
    </Grid>
  );
};
